import BundlePrice from '../../Bundles/BundlePrice';
import { Box, Stack } from '@mui/material';
import { SpecialOfferProps } from '../types';
import { StyledSpecialOffer } from './style';
import { HuuugeSaleBadge } from '../../Badge/Sale/HuuugeSaleBadge';

function MatchMastersSpecialOffer({
    text,
    price,
    design,
    textColor,
    borderColor,
    buttonColor,
    productsList,
    availability,
    backgroundColor,
    backgroundImage,
    selectOffer,
    inMobileMock = false,
    salePercentage = 0,
    salePercentageDisplayType,
    isFree,
    availabilityText = 'Available',
    collectText = 'Collect',
    specialOfferRef
}: SpecialOfferProps) {
    const availabilityString =
        availability?.remaining && availability?.total
            ? `${availabilityText} ${availability.remaining}/${availability.total}`
            : '';

    return (
        <StyledSpecialOffer
            className="match-masters-special-offer"
            ref={specialOfferRef}
            borderColor={borderColor}
            backgroundColor={backgroundColor}
            backgroundImage={backgroundImage}
            textColor={textColor}
            productsHeight={'50%'}
            mainHeight={'60%'}
            onClick={selectOffer}
            title={text}
        >
            <Box className="backgroundImage">
                {salePercentage > 0 && (
                    <HuuugeSaleBadge
                        salePercentage={salePercentage}
                        salePercentageDisplayType={salePercentageDisplayType}
                    />
                )}
                <Box
                    boxSizing={'border-box'}
                    display={'flex'}
                    flexDirection={'column'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    width={'100%'}
                    flexGrow={'1'}
                    padding={'1.5em 1em'}
                >
                    <h2 className="match">{text}</h2>
                    <Box className={`productsContainer match`}>
                        <Stack
                            className="products mainProducts match"
                            direction="row"
                        >
                            {productsList.map((product, index) => {
                                return (
                                    <Stack
                                        className="product__match"
                                        alignItems="center"
                                        key={index}
                                    >
                                        {product.images.product && (
                                            <Box
                                                height="62px"
                                                width="62px"
                                                className="image-container--match"
                                            >
                                                <img
                                                    src={product.images.product}
                                                    alt=""
                                                    className="image-container--image"
                                                />
                                            </Box>
                                        )}
                                        <Box
                                            display="flex"
                                            flexDirection="row"
                                            alignItems="center"
                                        >
                                            {product?.images?.productPrefix && (
                                                <Box
                                                    pr={1}
                                                    sx={{
                                                        height: '20px'
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            product.images
                                                                .productPrefix
                                                        }
                                                        alt=""
                                                        style={{
                                                            maxHeight: '20px',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                            <h4
                                                data-text={
                                                    product.quantityDisplay
                                                }
                                            >
                                                {product.quantityDisplay}
                                            </h4>
                                        </Box>
                                    </Stack>
                                );
                            })}
                        </Stack>
                    </Box>
                </Box>
                {availabilityString && (
                    <span className="availability quantity">
                        {availabilityString}
                    </span>
                )}
                <BundlePrice
                    height="30px"
                    price={price}
                    buttonTextColor="white"
                    buttonColor={buttonColor}
                    type={design}
                    textShadow="0px 2px 0px #000000"
                    borderRadius="0 0 9px 9px"
                    isPreview={inMobileMock}
                    availabilityText={availabilityText}
                    isFree={isFree}
                    buttonText={collectText}
                />
            </Box>
        </StyledSpecialOffer>
    );
}

export default MatchMastersSpecialOffer;
